import dayjs from "dayjs";

/***
 * dayjsのデフォルトのパース方法を拡張する関数。
 * これによりdayjs.extend()を使わずに、日付のパースを緩く拡張できる。
 */
export const getDayjs = (value?: string): dayjs.Dayjs | undefined => {
  /**
   * undefinedまたは空文字を、日付として扱わない
   */
  if (value === undefined || value === "") {
    return undefined;
  }

  /**
   * `dayjs`でパースできる場合は正しい日付として扱う。
   * `2021年2月29日`などはパース出来ない。
   */
  const date = dayjs(value);
  if (date.isValid()) {
    return date;
  }

  /**
   * 数字以外をスペースに置き換えてパース出来れば正しい日付として扱う。
   */
  const numbersOnly = dayjs(value.replace(/\D/g, " ").trim());
  if (numbersOnly.isValid()) {
    return numbersOnly;
  }

  return undefined;
};
